export default class {
  constructor($c) {
    this.$c = $c.jquery ? $c.get(0) : $c;
    if (this.$c.dataset.link) {
      this.$c.setAttribute('href', this.$c.dataset.link);
      this.$c.removeAttribute('data-link');
    }
  }
}
